/**
 * Conservative TLS-certificate-trust failure detection, shared by the
 * renderer's connection-error presentation and the main-process mssql error
 * formatter. Only phrases that unambiguously mean "the certificate itself was
 * rejected" belong here — generic network/SSL wording (handshake resets,
 * "wrong version number", plain ESOCKET) must NOT match, or ordinary connect
 * failures would surface a misleading certificate hint.
 */
const CERT_TRUST_PHRASES = [
  'self signed certificate',
  'self-signed certificate',
  'unable to verify the first certificate',
  'unable to get local issuer certificate',
  'certificate verify failed',
  'certificate has expired',
  'cert_has_expired',
  'depth_zero_self_signed_cert',
  'self_signed_cert_in_chain',
  'unable_to_verify_leaf_signature',
  "does not match certificate's altnames",
  // Microsoft.Data.SqlClient (SQL Tools Service leg) wording for the same
  // condition tedious reports as "self signed certificate".
  'certificate chain was issued by an authority that is not trusted',
];

export function isCertificateTrustError(text: string | undefined): boolean {
  if (!text) return false;
  const lowered = text.toLowerCase();
  return CERT_TRUST_PHRASES.some((phrase) => lowered.includes(phrase));
}
